<div class="box">
  <div class="modal-header">
    <h2 class="modal-title pull-left mr-4">
      {{
        isAwaitingNewPassword
          ? ('NEW_PASSWORD' | translate)
          : ('RESET_PASSWORD' | translate)
      }}
    </h2>
    <button
      type="button"
      class="close pull-right"
      title="{{ 'CLOSE' | translate }}"
      [attr.aria-label]="'CLOSE' | translate"
      (click)="hide()"
    ></button>
  </div>

  @if (!isAwaitingNewPassword && !isAwaitingSmsCheck) {
    <form #form="ngForm" #formEl spellcheck="false">
      <div class="modal-body">
        <div class="tabs tabs--in-box">
          <div class="nav" id="nav-tab" role="tablist">
            @for (type of types; track type) {
              <a
                class="nav-item nav-link"
                role="tab"
                [class.active]="type === activeType"
                (click)="changeTab(type)"
                >{{ typesMap.get(type) | translate }}</a
              >
            }
          </div>
          <div class="tabs__line" aria-hidden="true"></div>
        </div>
        <div class="tab-content" @parent>
          @switch (activeType) {
            @case ('individual') {
              <div class="form-control" @fadeInOut>
                <label for="phone-login">{{
                  'PHONE_NUMBER' | translate
                }}</label>
                <ngx-intl-tel-input
                  [onlyCountries]="['by']"
                  name="phone"
                  id="phone-login"
                  required
                  mobilePhone
                  ngModel
                  (ngModelChange)="
                    phone = $event ? $any($event).internationalNumber : ''
                  "
                  appAutofocus
                  ngxTelInputPlaceholder
                ></ngx-intl-tel-input>
                <app-control-errors control="phone"></app-control-errors>
              </div>
              <div class="form-control">
                <app-captcha ngModel name="captcha" required></app-captcha>
                <app-control-errors control="captcha"></app-control-errors>
              </div>
              <p>{{ 'RESET_PASSWORD_DESC_INDIVIDUAL' | translate }}</p>
            }
            @case ('legal') {
              <div class="form-control" @fadeInOut>
                <label for="tpi-forgot">{{ 'TPI_OR_EMAIL' | translate }}</label>
                <input
                  type="text"
                  name="login"
                  id="tpi-forgot"
                  [(ngModel)]="tpi"
                  required
                  maxlength="255"
                  appAutofocus
                  [asterisk]="false"
                />
                <app-control-errors control="login"></app-control-errors>
              </div>
              <app-filial-selector
                name="filial"
                [(ngModel)]="filial"
                [unp]="tpi"
              >
                <app-control-errors control="filial"></app-control-errors>
              </app-filial-selector>
              <p>{{ 'RESET_PASSWORD_DESC_LEGAL' | translate }}</p>
            }
          }
        </div>
        <app-control-errors></app-control-errors>
        <div class="text-center mb-3">
          <a class="pointer" (click)="toLogin()">{{
            'LOGIN_FOR_REGISTERED' | translate
          }}</a>
        </div>
      </div>
      <div class="modal-footer">
        <app-loading-button
          [disabled]="isLoading || (form.submitted && form.invalid)"
          [loading]="isLoading"
          (handleClick)="resetPassword()"
          type="submit"
          buttonClass="button button--filled button--shadow"
        >
          {{ 'CONTINUE' | translate }}
        </app-loading-button>
      </div>
    </form>
  } @else {
    <ng-template
      [ngTemplateOutlet]="isAwaitingSmsCheck ? smsCheck : newPassword"
    ></ng-template>
  }

  <ng-template #smsCheck>
    <form
      #formCode="ngForm"
      #formCodeEl
      (ngSubmit)="sendCode()"
      spellcheck="false"
    >
      <div class="modal-body">
        <!-- Enter sms code -->
        <p>
          {{ 'CODE_SENT_TO' | translate }}
          <span class="font-weight-medium">{{ phone }}</span>
        </p>
        <div class="form-control" @fadeInOut>
          <label for="code-forgot">{{ 'SMS_CODE' | translate }}</label>
          <input
            type="text"
            name="code"
            id="code-forgot"
            [(ngModel)]="code"
            placeholder="1 2 3 4"
            required
            mask="0 0 0 0"
            minlength="4"
            autocomplete="one-time-code"
            appAutofocus
            [asterisk]="false"
          />
          <app-control-errors control="code"></app-control-errors>
        </div>
        <ul class="list-column text-center mb-3">
          <!-- <li>
          <ng-container [counter]="30"
            [interval]="1000"
            (value)="count = $event"
            #counter="counter">
            <button class="text-link"
              type="button"
              [disabled]="isResendingCode || count > 0"
              (click)="resendCode(); counter.restart()">{{ 'RESEND_CODE' | translate }} <span *ngIf="count > 0">({{ count }})</span></button>
            </ng-container>
          </li> -->
          <li>
            <a class="pointer" (click)="toLogin()">{{
              'LOGIN_FOR_REGISTERED' | translate
            }}</a>
          </li>
        </ul>
        <app-control-errors></app-control-errors>
      </div>
      <div class="modal-footer">
        <app-loading-button
          [disabled]="isLoading || (formCode.submitted && formCode.invalid)"
          [loading]="isLoading"
          (handleClick)="sendCode()"
          type="submit"
          buttonClass="button button--filled button--shadow"
        >
          {{ 'CONTINUE' | translate }}
        </app-loading-button>
      </div>
    </form>
  </ng-template>

  <ng-template #newPassword>
    <form
      [formGroup]="formNewPassword"
      #formNewPasswordEl
      (ngSubmit)="sendNewPassword()"
      spellcheck="false"
    >
      <div class="modal-body">
        <div class="form-control">
          <label for="password-forgot">{{ 'NEW_PASSWORD' | translate }}</label>
          <div class="position-relative">
            <input
              type="password"
              name="password"
              id="password-forgot"
              class="pr-5"
              formControlName="password"
              placeholder="{{ 'NEW_PASSWORD_PLACEHOLDER' | translate }}"
              maxlength="255"
              appPassword
              appAutofocus
              autocomplete="new-password"
              [asterisk]="false"
            />
          </div>
          <app-password-validation
            [control]="formNewPassword.get('password')"
          ></app-password-validation>
        </div>
        <app-control-errors></app-control-errors>
      </div>
      <div class="modal-footer">
        <app-loading-button
          [disabled]="
            isLoading || (isFormNewPasswordSubmitted && formNewPassword.invalid)
          "
          [loading]="isLoading"
          (handleClick)="sendNewPassword()"
          type="submit"
          buttonClass="button button--filled button--shadow"
        >
          {{ 'CONTINUE' | translate }}
        </app-loading-button>
      </div>
    </form>
  </ng-template>
</div>
